export default __webpack_public_path__ + "static/media/burger.13b97581.svg";